import { pendingNavHrefAtom } from '@/atoms/sideNavAtoms';
import { WORK_CHAT_HOME_PATH } from '@heidi/agents/contracts';
import {
  pendingWorkHomeMode,
  pendingWorkHomeViewAtom,
  pendingWorkModeAtom,
} from '@heidi/agents/data';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/** Lands on Work Home in Work mode with the Tasks list expanded. */
export function useOpenHomeTasks(): () => void {
  const router = useRouter();
  const setPendingNavHref = useSetAtom(pendingNavHrefAtom);
  const setPendingWorkHomeView = useSetAtom(pendingWorkHomeViewAtom);
  const setPendingWorkMode = useSetAtom(pendingWorkModeAtom);

  return useCallback(() => {
    setPendingWorkHomeView('tasks');
    setPendingWorkMode(pendingWorkHomeMode);
    if (router.asPath !== WORK_CHAT_HOME_PATH) {
      setPendingNavHref(WORK_CHAT_HOME_PATH);
      void router.push(WORK_CHAT_HOME_PATH);
    }
  }, [router, setPendingNavHref, setPendingWorkHomeView, setPendingWorkMode]);
}
